import { render, staticRenderFns } from "./LoaderLight.vue?vue&type=template&id=840b7e7a&scoped=true&"
import script from "./LoaderLight.vue?vue&type=script&lang=js&"
export * from "./LoaderLight.vue?vue&type=script&lang=js&"
import style0 from "./LoaderLight.vue?vue&type=style&index=0&id=840b7e7a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "840b7e7a",
  null
  
)

export default component.exports